import type {
  HomeLocationFacet,
  SelectableSuggestionItem,
} from './LocationFilter';

type FlattenedNestedLocationProps =
  | {
      type: 'without-levels';
      location: HomeLocationFacet;
      group: string;
    }
  | {
      type: 'with-levels';
      location: HomeLocationFacet;
      level: number;
      group: string;
    };

export const flattenLocations = (
  props: FlattenedNestedLocationProps,
): SelectableSuggestionItem[] => {
  const suggestions: SelectableSuggestionItem[] = [];

  const recursivelyFlattenChildren = ({
    location,
    currentLevel,
  }: {
    location: HomeLocationFacet;
    currentLevel: number;
  }) => {
    suggestions.push({
      type: 'selectable-suggestion',
      id: location.homeLocation.id,
      name: location.homeLocation.description,
      indentLevel: props.type === 'with-levels' ? currentLevel : 0,
      count: location.count,
      group: props.group,
    });

    if (location.children && location.children.length > 0) {
      location.children.forEach((child) =>
        recursivelyFlattenChildren({
          location: child,
          currentLevel: currentLevel + 1,
        }),
      );
    }
  };

  recursivelyFlattenChildren({
    location: props.location,
    currentLevel: 0,
  });
  return suggestions;
};
